import BaseModel from '../../../model/BaseModel';
import HeartRate from '../../../model/HeartRate';
import Feature from '../../../strategy/Feature';

export default class MockHeartRate implements Feature {
  execute(): BaseModel {
    const min = Math.ceil(80);
    const max = Math.floor(120);
    return new HeartRate(Math.floor(Math.random() * (max - min)) + min);
  }
}
